import { endPoint } from './base.config';

export const bankTemplate = {
  getLinkIntegration: `${endPoint}v2/bank-templates/link-integration`,
  getAvailableRgbIntegration: `${endPoint}v2/bank-templates/:companyId/available-rgb-integration`,
  getBankTemplates: `${endPoint}v2/bank-templates`,
  getBankTemplate: `${endPoint}v2/bank-templates/:id/prefixes`,
  createBankTemplate: `${endPoint}v2/bank-templates`,
  updateBankTemplate: `${endPoint}v2/bank-templates/:id`,
  addBankTemplatePrefix: `${endPoint}v2/bank-templates/:id/prefixes`,
};
